<template>
    <div class="nav-temp-list">
        <el-collapse v-model="clpsValue">
            <el-collapse-item name="1">
                <template slot="title">
                    <div class="clps-title flex-r-s-c">
                        <div class="title-icon flex-c-c-c">
                            <img class="icon-img" src="@/static/user_clps_icon1.png" alt="">
                        </div>
                        <div class="title-text">作品管理</div>
                    </div>
                </template>
                <div class="cd-list">
                    <div @click="goPage('/userCenter/workRegistration')" :class="name == '作品登记' ? 'on' : ''" class="cd-li cur curadm">作品登记</div>
                    <div @click="goPage('/userCenter/mywork')" :class="name == '我的作品' ? 'on' : ''" class="cd-li cur curadm">我的作品</div>
                </div>
            </el-collapse-item>
            <el-collapse-item name="2">
                <template slot="title">
                    <div class="clps-title flex-r-s-c">
                        <div class="title-icon flex-c-c-c">
                            <img class="icon-img" src="@/static/user_clps_icon2.png" alt="">
                        </div>
                        <div :class="name == '账户服务' ? 'on' : ''" class="title-text">账户服务</div>
                    </div>
                </template>
                <div class="cd-list">
                    <div @click="goPage('/userCenter/vipService')" :class="name == '会员服务' ? 'on' : ''" class="cd-li cur curadm">会员服务</div>
                </div>
            </el-collapse-item>
            <el-collapse-item name="3">
                <template slot="title">
                    <div class="clps-title flex-r-s-c">
                        <div class="title-icon flex-c-c-c">
                            <img class="icon-img" src="@/static/user_clps_icon3.png" alt="">
                        </div>
                        <div class="title-text">设置</div>
                    </div>
                </template>
                <div class="cd-list">
                    <div :class="name == '个人信息' ? 'on' : ''" class="cd-li cur curadm" @click="goPage('/userCenter/userinfo')">个人信息</div>
                    <div :class="name == '账户安全' ? 'on' : ''" class="cd-li cur curadm">账户安全</div>
                    <div :class="name == '账户绑定' ? 'on' : ''" class="cd-li cur curadm" @click="goPage('/userCenter/userbind')">账户绑定</div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
import util from "@/common/util.js"
export default {
    name: 'centerNavBar',
    props: {
        // 外部参数示例
		name: {
		    type: String,
		    default: ""
		},
    },
    data() {
        return {
            // 内部参数
            clpsValue: ['1', '2', '3'],
        }
    },
    methods: {
       goPage(path) {
			util.tourl(path)
		},
    },
    mounted() {

    }

}
</script>
<style lang="scss">
@import "./navbar.scss";
</style>
